// extracted by mini-css-extract-plugin
export var noSpinners = "_sb-6";
export var percentageInput = "_sb-7";
export var variantColor1 = "_sb-0";
export var variantColor2 = "_sb-1";
export var variantColor3 = "_sb-2";
export var variantColor4 = "_sb-3";
export var variantColor5 = "_sb-4";
export var variantColor6 = "_sb-5";